import { kea } from 'kea'


import rootLogic from '~/scenes/logic'

export default kea({
  connect: {
    actions: [
      rootLogic, [
        'logout'
      ]
    ],
    values: [
      rootLogic, [
        'loggedIn',
        'userInfo'
      ]
    ]
  }
})
